export default __webpack_public_path__ + "static/media/bread(2).dd485726.png";